export default __webpack_public_path__ + "static/media/email1.e6271964.svg";